<template>
  <div class="legal-page">
    <Navigation />

    <h1>{{ $t('legal.aiAct.title') }}</h1>

    <section class="legal-section">
      <p class="legal-basis">{{ $t('legal.aiAct.legalBasis') }}</p>
      <p>{{ $t('legal.aiAct.intro') }}</p>

      <h2>{{ $t('legal.aiAct.scopeTitle') }}</h2>
      <p>{{ $t('legal.aiAct.scopeText') }}</p>

      <h2>{{ $t('legal.aiAct.systemsTitle') }}</h2>

      <h3>{{ $t('legal.aiAct.liveChatTitle') }}</h3>
      <p>{{ $t('legal.aiAct.liveChatText') }}</p>

      <h3>{{ $t('legal.aiAct.automationTitle') }}</h3>
      <p>{{ $t('legal.aiAct.automationText') }}</p>

      <h3>{{ $t('legal.aiAct.demoTitle') }}</h3>
      <p>{{ $t('legal.aiAct.demoText') }}</p>

      <h2>{{ $t('legal.aiAct.syntheticTitle') }}</h2>
      <p>{{ $t('legal.aiAct.syntheticText') }}</p>

      <h2>{{ $t('legal.aiAct.humanTitle') }}</h2>
      <p>{{ $t('legal.aiAct.humanText') }}</p>

      <h2>{{ $t('legal.aiAct.deployerTitle') }}</h2>
      <p>{{ $t('legal.aiAct.deployerText') }}</p>

      <h2>{{ $t('legal.aiAct.botTemplatesTitle') }}</h2>
      <p>{{ $t('legal.aiAct.botTemplatesIntro') }}</p>

      <h3>{{ $t('legal.aiAct.botWelcomeLabel') }}</h3>
      <p class="template-block">{{ $t('legal.aiAct.botWelcomeTemplate') }}</p>

      <h3>{{ $t('legal.aiAct.botAiNoticeLabel') }}</h3>
      <p class="template-block">{{ $t('legal.aiAct.botAiNoticeTemplate') }}</p>

      <h3>{{ $t('legal.aiAct.botImageLabel') }}</h3>
      <p class="template-block">{{ $t('legal.aiAct.botImageTemplate') }}</p>

      <p>{{ $t('legal.aiAct.botSetupHint') }}</p>

      <h2>{{ $t('legal.aiAct.rightsTitle') }}</h2>
      <p>{{ $t('legal.aiAct.rightsText') }}</p>

      <h2>{{ $t('legal.aiAct.contactTitle') }}</h2>
      <p>{{ $t('legal.aiAct.contactText') }}</p>
      <p>{{ $t('legal.imprint.email') }}</p>
      <p>{{ $t('legal.imprint.phone') }}</p>

      <p class="status-note"><strong>{{ $t('legal.aiAct.statusLabel') }}</strong> {{ $t('legal.aiAct.statusDate') }}</p>
    </section>

    <LegalFooter />
  </div>
</template>

<script>
import Navigation from '../sections/Navigation.vue'
import LegalFooter from './LegalFooter.vue'

export default {
  name: 'LegalAIAct',
  components: { Navigation, LegalFooter }
}
</script>

<style scoped>
.legal-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 120px 20px 0;
  color: #e2e8f0;
  min-height: 100vh;
}

h1 {
  font-size: 3rem;
  margin-bottom: 40px;
  color: #ffffff;
  text-align: center;
  font-weight: 700;
}

.legal-section {
  background: rgba(15, 16, 35, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #e2e8f0;
  padding: 40px;
  border-radius: 15px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.4);
  margin-bottom: 30px;
}

.legal-basis {
  font-size: 0.9rem;
  opacity: 0.8;
  margin-bottom: 24px;
}

h2 {
  color: #ffffff;
  margin: 30px 0 15px;
  font-size: 1.5rem;
  font-weight: 600;
  border-bottom: 2px solid #00ffb3;
  padding-bottom: 8px;
}

h3 {
  color: #ffffff;
  margin: 20px 0 10px;
  font-size: 1.2rem;
  font-weight: 600;
}

p {
  margin: 10px 0;
  line-height: 1.6;
  color: #e2e8f0;
}

.status-note {
  margin-top: 24px;
  font-size: 0.9rem;
  opacity: 0.85;
}

.template-block {
  white-space: pre-line;
  background: rgba(0, 0, 0, 0.3);
  padding: 16px 18px;
  border-radius: 8px;
  border-left: 3px solid #00ffb3;
  font-size: 0.92rem;
}

@media (max-width: 768px) {
  .legal-page {
    padding-top: 100px;
  }

  h1 {
    font-size: 2.5rem;
  }

  .legal-section {
    padding: 30px 20px;
  }
}
</style>
